import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LazyImageModule } from '@/helpers/lazyImageModule';
import { FooterComponent } from './footer.component';

@NgModule({
    imports: [ RouterModule, CommonModule, LazyImageModule ],
    declarations: [ FooterComponent ],
    exports: [ FooterComponent ],
})

export class FooterModule {}